import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';
import Modifier from 'ember-modifier';

export default class CloseOnClickOutside extends Modifier {
  element = null;
  handleClose = null;
  selector = null;

  @service fastboot;

  cleanup = () => {
    if (!this.fastboot?.isFastBoot) {
      document.removeEventListener('click', this.onClickOutside);
    }

    this.element = null;
    this.handleClose = null;
    this.selector = null;
  };

  modify = (element, [handler, selector]) => {
    this.element = element;

    this.handleClose = handler;
    this.selector = selector;

    if (!this.fastboot?.isFastBoot) {
      document.addEventListener('click', this.onClickOutside);
    }

    registerDestructor(this, this.cleanup);
  };

  onClickOutside = event => {
    let { target } = event;
    // Resolve containment from the event's composed path (captured at dispatch time)
    // so a click that originated inside the element is still treated as "inside" even
    // if the clicked node (e.g. a conditionally rendered clear button) is removed from
    // the DOM during the same click. Falls back to `contains` for older event targets.
    let path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    let clickedInside = path.includes(this.element) || this.element.contains(target);

    if (!clickedInside || target.classList?.contains(this.selector)) {
      this.handleClose();
    }
  };
}
